/**
 * Fires the same GTM tracking the Vue form's submitForm()/postFormDataToGtm() pushed on
 * success, once the confirmation partial swaps into the turbo frame.
 */
import { Controller } from '@hotwired/stimulus'
import { trackPageView, trackFormSubmission } from '../default/google_tag_manager.js'

export default class extends Controller {
  static values = { email: String, phone: String }

  connect() {
    trackPageView(
      `https://${window.location.host}/info-request-thank-you`,
      'Info Request Thank You',
      '/info-request-thank-you'
    )
    trackFormSubmission(this.emailValue, this.phoneValue)
  }
}
